import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/core/shared/http.service';
import { UserGroupErrorType } from '../interfaces/user-group-error-type';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserGroupErrorTypeService {

  constructor(private httpService: HttpService) { }

  public createUserGroupErrorType(userGroupErrorType: UserGroupErrorType): Observable<UserGroupErrorType> {
    return this.httpService.post<UserGroupErrorType>('UserGroupErrorType', userGroupErrorType);
  }

  public deleteUserGroupErrorType(id: number): Observable<any> {
    return this.httpService.delete<any>(`UserGroupErrorType/${id}`);
  }

  public getUserGroupErrorTypes(): Observable<UserGroupErrorType> {
    return this.httpService.get<UserGroupErrorType>('UserGroupErrorType');
  }

  public updateUserGroupErrorType(userGroupErrorType: UserGroupErrorType): Observable<UserGroupErrorType> {
    return this.httpService.put<UserGroupErrorType>(`UserGroupErrorType/${userGroupErrorType.id}`, userGroupErrorType);
  }

  public getUserGroupErrorTypeById(id: number): Observable<UserGroupErrorType> {
    return this.httpService.get<UserGroupErrorType>(`UserGroupErrorType/${id}`);
  }

/* GET
/UserGroupErrorType/GetByUserId/{id}
Get UserGroupErrorType from DB by UserId

Sample request:

.UserGroupErrorType/GetByUserId/{id}
Parameters
Name	Description
id *
integer($int32)
(path)
	
 */
  public getUserGroupErrorTypeByUserId(id: number): Observable<UserGroupErrorType[]> {
    return this.httpService.get<UserGroupErrorType[]>(`UserGroupErrorType/GetByUserId/${id}`);
  }

  
}